var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.864,3L5.136,3C4.702,3 4.286,3.172 3.979,3.479C3.672,3.786 3.5,4.202 3.5,4.636L3.5,19.364C3.5,19.798 3.672,20.214 3.979,20.521C4.286,20.828 4.702,21 5.136,21L19.864,21C20.298,21 20.714,20.828 21.021,20.521C21.328,20.214 21.5,19.798 21.5,19.364L21.5,4.636C21.5,4.202 21.328,3.786 21.021,3.479C20.714,3.172 20.298,3 19.864,3ZM19.864,11.182L13.318,11.182L13.318,4.636L19.864,4.636L19.864,11.182ZM11.682,4.636L11.682,11.182L5.136,11.182L5.136,4.636L11.682,4.636ZM5.136,12.818L11.682,12.818L11.682,19.364L5.136,19.364L5.136,12.818ZM19.864,19.364L13.318,19.364L13.318,12.818L19.864,12.818L19.864,19.364Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridIcon);
export default __webpack_public_path__ + "static/media/grid-icon.ac7108ca51f6a6b1475fdcc2afd81386.svg";
export { ForwardRef as ReactComponent };